//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "TOPIC",
  components: {},
  props: ["moduleData"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    handleWidth: function handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "33.3%";

        case 4:
          return "25%";

        case 5:
          return "20%";

        case 6:
          return "16.6%";

        default:
          return "50%";
      }
    },
    goServe: function goServe(item) {
      var routeData = null;

      if (item.serveType == "0" && item.queryType == "2") {
        // 本地查询类
        routeData = this.$router.resolve({
          name: item.queryPcUrl
        });
        window.open(routeData.href);
      }

      if (item.serveType == "0" && item.queryType == "1") {
        //流程查询类
        window.open(item.queryPcUrl);
      } else {
        routeData = this.$router.resolve({
          path: "/ServeCenterDetail?id=".concat(item.serveId)
        });
        window.open(routeData.href);
      }
    }
  },
  watch: {},
  filters: {}
};